import React from "react";
import {
  qhseBg,
  supplyCorebit1,
  supplyCorebit2,
} from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Corebit = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Corebit" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Text */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("CORE BIT")}
            </p>

            <p className="mt-4 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "Our advantage in this area, is the ability to select and apply simultaneously several successful solutions and technologies from different manufacturers for specific geological and technical conditions of the Customer."
              )}
            </p>

            <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t("Core Bit Types by Rock Formation")}
            </p>
            <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>{t("Soft Rock - PDC")}</li>
              <li>{t("Medium to Hard Rock - PDC")}</li>
              <li>{t("Fractured - Impregnated")}</li>
              <li>{t("Ultra hard and abrasive - Impregnated")}</li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="md:w-1/2 grid grid-cols-2 gap-4 mt-8 md:mt-0">
            <img
              src={supplyCorebit1}
              alt="Drill Bit 1"
              className="w-full rounded-lg shadow-md"
            />
            <img
              src={supplyCorebit2}
              alt="Drill Bit 2"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Corebit;
